import React from 'react';
import styled from 'styled-components';

const StyledParagraph = styled.p`
  width: 100%;
  max-width: 600px;
  hyphens: auto;
`;

function Words({ path, content }) {
  return <StyledParagraph>{content}</StyledParagraph>;
}

export default Words;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Words.js